import { HStack } from "@chakra-ui/react"
import RunDry from "@hydrologiq/shared/asset/attributes/RunDry"

interface SystemRunDryIconProps {
  runDryMinutes?: number
  system?: string
  systemId?: string
  icon?: boolean
}

function SystemRunDryIcon({ runDryMinutes, system, systemId, icon = true }: SystemRunDryIconProps) {
  return (
    <HStack justify="center" width="100%" display="inline-flex">
      <RunDry
        minutes={runDryMinutes}
        system={system}
        systemId={systemId}
        icon={icon}
        iconType="truck"
      />
    </HStack>
  )
}

export default SystemRunDryIcon
